module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_5010.d42eb646.png";